module.exports = __webpack_public_path__ + "img/slider1.26fa029d.jpg";